import { IconPropsType } from '..';

export const DrawerIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.99998 15H12V13H1.99998V15ZM4.99998 11H15V9H4.99998V11ZM7.99998 7H18V5H7.99998V7Z"
      fill="currentColor"
    />
  </svg>
);
